<script setup lang="ts">
import { DgrIcon } from '@stockmarkteam/donguri-ui';
import InsightSource from '@/components/home/insights/insight-source.vue';
import { useInsightSources } from '@/components/home/insights/use-insight-sources';
import type { InsightTopic } from '@/types/insights';

interface Props {
  topics: InsightTopic[];
}

defineProps<Props>();

const { resolveSources } = useInsightSources();
</script>

<template>
  <div class="insight-topic-card">
    <div class="c-title-bold--s title">
      <DgrIcon name="summary" size="small" :keep-fill="false" />
      トピック
    </div>
    <ol class="c-text-regular--m">
      <li v-for="topic in topics" :key="topic.text">
        <span>
          {{ topic.text }}
          <InsightSource
            v-for="source in resolveSources(topic.sources)"
            :key="source.position"
            :position="source.position"
            :adp-document="source.document"
            :insight-source-id="source.insightSourceId"
            :location="{ source_location: 'topic', topicId: topic.id }"
          />
        </span>
      </li>
    </ol>
  </div>
</template>

<style lang="scss" scoped>
.insight-topic-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: $color-gray200;
  border-radius: 4px;

  .title {
    display: flex;
    gap: 2px;
    width: fit-content;
    padding: 4px;
    border-radius: 4px;
    justify-content: center;

    color: #fff;
    fill: #fff;
    background-color: $color-gray1000;
  }

  ol {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding-left: 0;
    list-style: none;
    counter-reset: insight-topic;

    li {
      display: flex;
      align-items: flex-start;
      gap: 4px;
      counter-increment: insight-topic;

      .insight-source {
        vertical-align: center;
      }

      &::before {
        content: counter(insight-topic);
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        width: 14px;
        height: 14px;
        margin-top: 4px;
        border-radius: 50%;
        background-color: $color-gray1000;
        color: #fff;
        font-size: 10px;
        line-height: 13px;
      }
    }
  }
}
</style>
